interface IFeatureFlags {
  CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: boolean
}

const configuration: Record<string, IFeatureFlags> = {
  development: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
  },
  staging: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
  },
  interop: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
  },
  beta: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
  },
  production: {
    CONTENT_LIBRARY_ACCESSIBLE_TO_PUBLIC: true,
  },
}

export const featureFlags =
  configuration[(process.env.mode || process.env.NODE_ENV) as string]
